<template>
  <div class="flex flex-col gap-2">
    <gallery
      :files="filteredFiles"
      :busy="uploadingCount > 0"
      @delete="deleteFile"
      @upload="uploadFile"
    />
  </div>
</template>

<script>
const Gallery = () => import('@/components/global/gallery/Gallery.vue');

export default {
  name: 'CandleFiles',
  components: {
    Gallery,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    fileSource: {
      type: String,
      required: true,
    },
    strictSource: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    fileSources() {
      if (this.files === null) {
        return [];
      }
      const uniqueSources = [...new Set(this.files.map((file) => file.source))];
      const fileSources = uniqueSources.map((source) => ({
        text: source,
        value: source,
      }));
      fileSources.unshift({ text: 'All', value: null });
      return fileSources;
    },
    filteredFiles() {
      if (this.files === null) {
        return null;
      }
      const fileSource = this.strictSource ? this.fileSource : this.filters.fileSource;
      if (fileSource === null) {
        return this.files;
      }
      return this.files.filter((file) => file.source === fileSource);
    },
  },
  data() {
    return {
      loadingCount: 0,
      uploadingCount: 0,
      filters: {
        fileSource: null,
      },
      files: null,
    };
  },
  methods: {
    uploadFile(uploadFile) {
      this.loadingCount++;
      this.uploadingCount++;
      const formData = new FormData();
      formData.append('file', uploadFile);
      formData.append('mtime', uploadFile.lastModified / 1000);
      formData.append('fileSource', this.fileSource);
      this.$http
        .post(`/candle/${this.id}/files`)
        .send(formData)
        .then((res) => {
          this.files.push(res.body.file);
        })
        .catch((err) => {
          this.$toast.error(`Failed to upload file: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
          this.uploadingCount--;
        });
    },
    deleteFile(deleteFile) {
      this.loadingCount++;
      this.$http
        .delete(`/candle/${this.id}/files/${deleteFile.id}`)
        .then(() => {
          this.files = this.files.filter((file) => file.id !== deleteFile.id);
          this.$emit('deleted', deleteFile.id);
        })
        .catch((err) => {
          this.$toast.error(`Failed to delete file: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    fetchFiles() {
      this.loadingCount++;
      this.$http
        .get(`/candle/${this.id}/files`)
        .then((res) => {
          this.files = res.body;
        })
        .catch((err) => {
          this.$toast.error(`Failed to fetch files: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.fetchFiles();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
